import { render, staticRenderFns } from "./efficiencyAnalysis.vue?vue&type=template&id=ef895b6e&scoped=true&"
import script from "./efficiencyAnalysis.vue?vue&type=script&lang=js&"
export * from "./efficiencyAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./efficiencyAnalysis.vue?vue&type=style&index=0&id=ef895b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef895b6e",
  null
  
)

export default component.exports